import { Select } from 'antd';
import React from 'react';
import {RoleType} from 'graphql/types/AccountType';
import { useTranslation } from 'react-i18next';
import InputFilterItem from '../../../delivery/components/InputFilterItem';
import { useFilterContainerClassName, useFilterLabelClassName, useFilterInputContainerClassName } from '../../../../utils/languageUtils';
import { getSmartLabelClassName } from '../../../../utils/labelWidthUtils';

export interface FilterOptions {
    role: RoleType | 'all';
    id: string;
    name: string;
    phone: string;
    carrierId: number | null;
    status: number;
}

interface StatusOption {
    value: number;
    label: string;
}



interface FilterAreaProps {
    carrierOptions: { label: string; value: number; status?: number }[];
    filters: FilterOptions;
    setFilters: (filters: FilterOptions) => void;
}



export const DEFAULT_FILTER_OPTIONS: FilterOptions = {
    role: 'all',
    id: '',
    name: '',
    phone: '',
    carrierId: null,
    status: 2,
};

const FilterArea: React.FC<FilterAreaProps> = ({ carrierOptions, filters, setFilters }) => {
    const { t } = useTranslation();
    const containerClassName = useFilterContainerClassName();
    const labelClassName = useFilterLabelClassName();
    const inputContainerClassName = useFilterInputContainerClassName();
    const STATUS_OPTIONS: StatusOption[] = [
        {value: 2, label: t('enum.activeStatus.all')},
        {value: 1, label: t('enum.activeStatus.active')},
        {value: 0, label: t('enum.activeStatus.suspended')},
    ];
    // 筛选区域只显示启用状态的承运商
    const activeCarrierOptions = carrierOptions.filter(c => c.status !== 0);

    // 定义列标签数组用于对齐计算（三列布局）
    const column1Labels = [t('pickup.account.filters.personnelId'), t('tms.vehicle.filters.carrier')];
    const column2Labels = [t('pickup.account.filters.name'), t('pickup.account.filters.status')];
    const column3Labels = [t('pickup.account.filters.phone')];

    const handleFilterChange = (name: string, value: any) => {
        setFilters({
            ...filters,
            [name]: value
        } as FilterOptions);
    };

    return (
        <div className="mb-2 pl-0 py-2">
            {/* 使用 Grid 布局确保列对齐 */}
            <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
                <div className="min-w-0">
                    <InputFilterItem
                        label={t('pickup.account.filters.personnelId')}
                        value={filters.id}
                        onChange={(e) => handleFilterChange('id', e.target.value)}
                        className={containerClassName}
                        spanClassName={getSmartLabelClassName(column1Labels)}
                    />
                </div>
                <div className="min-w-0">
                    <InputFilterItem
                        label={t('pickup.account.filters.name')}
                        value={filters.name}
                        onChange={(e) => handleFilterChange('name', e.target.value)}
                        className={containerClassName}
                        spanClassName={getSmartLabelClassName(column2Labels)}
                    />
                </div>
                <div className="min-w-0">
                    <InputFilterItem
                        label={t('pickup.account.filters.phone')}
                        value={filters.phone}
                        onChange={(e) => handleFilterChange('phone', e.target.value)}
                        className={containerClassName}
                        spanClassName={getSmartLabelClassName(column3Labels)}
                    />
                </div>
                {/* 第二行 */}
                <div className="min-w-0">
                    <div className={containerClassName}>
                        <span className={`${labelClassName} ${getSmartLabelClassName(column1Labels)}`}>
                            {t('tms.vehicle.filters.carrier')}
                        </span>
                        <div className={inputContainerClassName}>
                            <Select
                                placeholder={t('components.input.all') || undefined}
                                className="w-full"
                                size="middle"
                                options={activeCarrierOptions}
                                value={filters.carrierId}
                                onChange={(value) => handleFilterChange('carrierId', value)}
                                allowClear
                            />
                        </div>
                    </div>
                </div>
                <div className="min-w-0">
                    <div className={containerClassName}>
                        <span className={`${labelClassName} ${getSmartLabelClassName(column2Labels)}`}>
                            {t('pickup.account.filters.status')}
                        </span>
                        <div className={inputContainerClassName}>
                            <Select
                                placeholder={t('components.input.all') || undefined}
                                className="w-full"
                                size="middle"
                                options={STATUS_OPTIONS}
                                value={filters.status}
                                onChange={(value) => handleFilterChange('status', value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="min-w-0"></div>
            </div>
        </div>
    );
};

export default FilterArea;